export const getSkeletonNotMockedArray = (array: any[]): any[] => {
  const skeletonNotMockedArray = array.filter((item) => !item.isMocked);

  return skeletonNotMockedArray;
};
